<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { fetchCategory } from '@/api/category'
import BlackFriday from '@/components/BlackFriday.vue';
import ChristmasPromo from '@/components/ChristmasPromo.vue';

const props = defineProps({
    name: {
        type : String,
        required: true
    },
    cat_id: {
        type: String , Number,
        required: true
    }
})

const cateogry = ref({
    menu:{},
    produits:[]
})

const products = computed(()=>{
    const prods = [];
    cateogry.value.produits.forEach((prod)=>{
        if(!prods.includes(prod.code_produit)){
            prods.push(prod.code_produit)
        }
    })
    return prods
})

onMounted(()=>{
    
    fetchCategory(props.cat_id).then((res)=>{
        cateogry.value = res
    })
        

})

</script>
<template>
    <BlackFriday variant="compact" />
    <ChristmasPromo variant="compact" />
    <div>
        <h1>Category</h1>
        cat_name = {{props.name}}<br />
        cat_id = {{props.cat_id}}<br />
        <h3>Products :</h3>
        <div class="d-flex flex-wrap">
            <ProductPreview v-for="prod in products" :key="prod" :id="prod" />
        </div>
    </div>
</template>
<route lang="yaml">
name: category
props: true
meta:
    title: Category Kase
    layout: default
    middleware: guest
</route>